import {useEffect, useState} from 'react';
import {Link} from 'react-router';
import {Button, Modal, Table} from 'antd';
import {getAllPurchaseOrderLines, updatePurchaseOrderLineState} from "../../api/Api";
import {PurchaseOrderItemStatusType} from "../../api/Constants";
import {PurchaseOrderItemStatusTag} from "../widget/PurchaseOrderItemStatusTag";

export const RequestedItems = ({onApiFail, refresh, onRefresh, props}) => {
    const [requestedItems, setRequestedItems] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalItem, setModalItem] = useState(undefined);

    useEffect(() => {
        getAllPurchaseOrderLines(PurchaseOrderItemStatusType.InProgress).then(r => {
            const lines = r.map(l => {
                return {
                    ...l,
                    key: l.id
                }
            });
            setRequestedItems(lines);
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [refresh, onApiFail]);

    const columns = [
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity'
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (val, record, index) => {
                let name = val;
                if ((val === undefined) || (val === null)) {
                    name = "none specified"
                }
                return <Link to={`/purchaseorder/${record.purchaseId}/lineItem/${record.id}`}>{name}</Link>
            }
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (val, record, index) => <PurchaseOrderItemStatusTag item={record} />
        },
        {
            title: 'Purchase Order',
            dataIndex: 'poNumber',
            key: 'poNumber',
            render: (val, record, index) => {
                return <Link to={`/purchaseorder/${record.purchaseId}`}>{val}</Link>
            }
        },
        {
           title: 'Mark Complete',
           dataIndex: 'status',
           key: 'MarkComplete',
           render: (val, record, index) => {
               return <Button onClick={onComplete(record)}>Complete</Button>
           }
        }
    ];

    const onComplete = (record) => () => {
        setModalItem(record);
        setIsModalOpen(true);
    }

    const onModalOk = () => {
        updatePurchaseOrderLineState(modalItem.id, PurchaseOrderItemStatusType.Complete).then(r => {
            if (onRefresh) onRefresh();
        }).catch (e => {})
        setIsModalOpen(false);
    }

    const onModalCancel= () => {
        setIsModalOpen(false);
    }

    return <div>
        <Modal open={isModalOpen} onOk={onModalOk} onCancel={onModalCancel}>
            Marking this item as complete will indicate this work was previously completed.  No further ingredients will be recorded.  Do you wish to continue?
        </Modal>
        <Table dataSource={requestedItems} columns={columns} pagination={false} />
    </div>
}